import {createFragmentContainer, graphql} from 'react-relay';
import {sortBreakdownDeliverables} from '../ProjectPortfolioReportUtils';
import {useIntl} from 'react-intl';
import {DELIVERABLE_BREAKDOWN_TYPE} from '../../../../constants';

const DeliverableLoader = ({relay, viewer, children, ...props}) => {
	const intl = useIntl();
	const {formatMessage} = intl;
	const formatData = () => {
		const currency = viewer.company.currency;
		const deliverableBreakdownData = viewer.project.deliverableFinancialBreakdown.map(deliverableFinancialBreakdown => {
			const data = {...deliverableFinancialBreakdown, currency};
			if (!data.deliverable && data.breakdownType === DELIVERABLE_BREAKDOWN_TYPE.DELIVERABLE) {
				data.deliverable = {
					name: formatMessage({id: 'project_portfolio_report.deleted_deliverable'}),
				};
			}
			return data;
		});

		sortBreakdownDeliverables(deliverableBreakdownData);
		return deliverableBreakdownData;
	};
	return children({data: {rows: formatData()}, ...props});
};

export const deliverableLoaderQuery = graphql`
	query DeliverableLoader_Query(
		$startYear: Int
		$startMonth: Int
		$startDay: Int
		$endYear: Int
		$endMonth: Int
		$endDay: Int
		$projectId: ID!
		$ignoreBaselineWinChance: Boolean
		$excludeOpportunityActuals: Boolean
	) {
		viewer {
			actualPersonId
			component(name: "project_portfolio_period_deliverable_loader")
			...DeliverableLoader_viewer
				@arguments(
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					projectId: $projectId
					ignoreBaselineWinChance: $ignoreBaselineWinChance
					excludeOpportunityActuals: $excludeOpportunityActuals
				)
		}
	}
`;

export default createFragmentContainer(DeliverableLoader, {
	viewer: graphql`
		fragment DeliverableLoader_viewer on Viewer
		@argumentDefinitions(
			startYear: {type: "Int"}
			startMonth: {type: "Int"}
			startDay: {type: "Int"}
			endYear: {type: "Int"}
			endMonth: {type: "Int"}
			endDay: {type: "Int"}
			projectId: {type: "ID!"}
			ignoreBaselineWinChance: {type: "Boolean"}
			excludeOpportunityActuals: {type: "Boolean"}
		) {
			id
			company {
				currency
			}
			project(internalId: $projectId) {
				budgetBaseCurrency
				deliverableFinancialBreakdown(
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					filterRowsWithNoValues: true
					ignoreBaselineWinChance: $ignoreBaselineWinChance
					excludeOpportunityActuals: $excludeOpportunityActuals
				) {
					breakdownType
					deliverable {
						id
						name
					}
					financialNumbers {
						...ProjectPortfolioPeriodRow_financialNumbers
					}
				}
			}
		}
	`,
});
